import { SvgIcon, SvgIconProps } from "@mui/material";

export const CloseButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M18 6L6 18M6 6L18 18" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};

export const TransactionFromIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="16" fill="url(#paint0_radial_34168_7494)" />
      <path
        d="M16 10.75V21.25M16 21.25L10.75 16M16 21.25L21.25 16"
        stroke="#2C4DED"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_34168_7494"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16 16) rotate(90) scale(16)"
        >
          <stop stop-color="#E8EBFD" />
          <stop offset="1" stop-color="#A1B0F7" />
        </radialGradient>
      </defs>
    </SvgIcon>
  );
};

export const TransactionToIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="16" fill="url(#paint0_radial_34168_7734)" />
      <path
        d="M16 21.25V10.75M16 10.75L10.75 16M16 10.75L21.25 16"
        stroke="#BA800D"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial_34168_7734"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16 16) rotate(90) scale(16)"
        >
          <stop stop-color="#FAE4B8" />
          <stop offset="1" stop-color="#FFD233" />
        </radialGradient>
      </defs>
    </SvgIcon>
  );
};
